import { Box, CircularProgress } from '@mui/material';

const PageLoader = () => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', my: 8 }}>
    <CircularProgress />
  </Box>
);

export default PageLoader;
